<template>
  <!-- list-type:text 文件上传格式 -->
  <div class="textType-box">
    <ul class="filelist-ul" v-show="fileList.length">
      <li class="items" v-for="(file, index) in fileList" :key="file.uid">
        <p class="_info">
          <i class="el-icon-document"></i>
          <span class="txt" :title="file.name">{{ file.name }}</span>
          <span v-if="file.status === 'success'&& viewShow(file)" @click.stop="imgViewClick(file)" class="view">预览</span>
          <span
            v-if="file.status === 'success'"
            @click.stop="deleteUploadHandle(index)"
            class="dle"
            >删除</span
          >
        </p>
        <div v-if="file.status === 'ready' || file.status === 'uploading'">
          <div class="progress-item">
            <el-progress
              :show-text="false"
              :stroke-width="2"
              :percentage="uploadPercent"
            ></el-progress>
          </div>
        </div>
      </li>
    </ul>
    <ImageView :imgViewShow="imgViewShow" :imgList="imgViewList" @closeImgView="closeImgView" v-if="imgViewShow"/>
  </div>
</template>

<script>
import ImageView from './ImageView.vue'
// import PdfView from './PdfView.vue'
export default {
  name: 'TextTypeBox',
  components: {
    ImageView,
    // PdfView
  },
  data() {
    return {
      imgViewShow: false, // 图片预览,
      imgViewList: [], // 预览图片文件列表
      acceptImageType: ['.png', '.jpg', '.jpeg', '.webp', '.bmp', '.svg'],
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    uploadPercent: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },
    // 关闭图片预览
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
    // 点击预览
    imgViewClick(file) {
      const type = this.getFileType(file.name)
      if (this.acceptImageType.includes(type.toLowerCase())) {
        this.imgViewShow = true
        this.imgViewList.push(file.url)
      }
    },
    // 获取文件类型
    getFileType(file) {
      if (file) {
        return file.slice(file.lastIndexOf('.'))
      } else {
        return ''
      }
    },
    // 图片预览显示
    viewShow(file) {
      const type = this.getFileType(file.name)
      if (this.acceptImageType.includes(type.toLowerCase())) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
</style>
